import { Component, OnInit, Input } from '@angular/core';
import { HttpCallService } from 'src/app/services/http-call.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment.prod';
import { AddEditServiceInsurancePricesComponent } from '../add-edit-service-insurance-prices/add-edit-service-insurance-prices.component';
import { SpinnerService } from 'src/app/services/spinner.service';
import { EChartOption } from 'echarts';

@Component({
  selector: 'app-insurance-prices',
  templateUrl: './insurance-prices.component.html',
  styleUrls: ['./insurance-prices.component.scss']
})
export class InsurancePricesComponent implements OnInit {

  codeTypes = environment.codeTypes;
  isLoggedIn:any = false;
  hasHistory:boolean;
  ipRes:boolean = false;
  pRes:boolean = false;
  providerId: any;
  providerDetails: any;
  proThemes: any;

  constructor(
    public httpCall: HttpCallService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public dialog: MatDialog,
    private snackbar: MatSnackBar,
    private spinner: SpinnerService,
    private location: Location
  ) {
    this.activatedRoute.params.subscribe(params => {
      if(params) {
        this.getSingleServiceInsurancePricesData(params.mixedID);
      }
    });
    this.activatedRoute.queryParams.subscribe( params => {
      if(params){
        this.providerId = params.proId;
        this.getProviderDetails(this.providerId);
      }
    } )
    this.hasHistory = this.router.navigated;
  }

  getProviderDetails(proID) {
    this.spinner.showSpinner('Loading...Please Wait');
    this.httpCall.get(`${environment.providerDomain}/BackEnd/providerProfile/${proID}`).subscribe(res => {
      this.spinner.stopSpinner();
      if (res['success']) {
        this.providerDetails = res['response'];
        this.proThemes = res['response'].theme;
        this.setGraphValues();
      } else {
        this.snackbar.open(res['message'], 'Failed', {
          duration: 5000,
          panelClass: 'snackBar-failure'
        });
      }
    }, (err) => {
      this.spinner.stopSpinner();
      this.snackbar.open(err.error['message'], 'Failed', {
        duration: 5000,
        panelClass: 'snackBar-failure'
      });
    });
  }

  backToPreviousPage() {
    this.location.back();
  }

  _selectedColumns: any[] = [];
  filterColumns: any[] = [];
  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  toggler=false;

  set selectedColumns(val: any[]) {
    //restore original order
    if(val.length >= 0){
      this._selectedColumns = this.filterColumns.filter(col => val.includes(col));
      this.insurancePricesList = [ ...this._selectedColumns];
      this.setGraphValues();
      console.log(this.insurancePricesList);
      console.log(val);
    }else{
      this.toggler = !this.toggler;
    }
  }

  ngOnInit(): void {
    if(localStorage.getItem('token') != undefined){
      this.isLoggedIn = true;
    }
    this.getSingleServiceData(this.activatedRoute.snapshot.params.serviceID);
    this.insurancePricesList = [ ...this._selectedColumns];
  }

  serviceImagePath: string;
  serviceItemObj: any = {};
  testPricesList: any = [];
  getSingleServiceData(serviceID) {
    this.spinner.showSpinner('Loading...Please Wait');
    this.httpCall.get(`${environment.providerDomain}/BackEnd/fetchNewSingleProviderTest/${serviceID}`).subscribe(res => {
      this.pRes = true;
      this.spinner.stopSpinner();
      if (res['success']) {
        this.serviceItemObj = res['response'][0];
        this.testPricesList = [
          { carrier_name: 'GROSS PRICE', ip_price: this.serviceItemObj?.std_price_ip, op_price: this.serviceItemObj?.std_price_op },
          { carrier_name: 'CASH PRICE', ip_price: this.serviceItemObj?.cash_price_ip, op_price: this.serviceItemObj?.cash_price_op },
          { carrier_name: 'MIN PRICE', ip_price: this.serviceItemObj?.min_price_ip, op_price: this.serviceItemObj?.min_price_op },
          { carrier_name: 'MAX PRICE', ip_price: this.serviceItemObj?.max_price_ip, op_price: this.serviceItemObj?.max_price_op },
          { carrier_name: 'OUT OF NETWORK PRICE', ip_price: this.serviceItemObj?.outofnetwork_ip, op_price: this.serviceItemObj?.outofnetwork_op },
        ];
        this.serviceImagePath = this.serviceItemObj.isMandatory == true ? `https://zea-tool.s3.amazonaws.com/${this.serviceItemObj.cpt_code}.png` : 'assets/img/service-default.png';
        // this.getSingleServiceInsurancePricesData(this.activatedRoute.snapshot.params.mixedID);
      }
    }, (err) => {
      this.spinner.stopSpinner();
      this.snackbar.open(err.error['message'], 'Failed', {
        duration: 5000,
        panelClass: 'snackBar-failure'
      });
    });
  }

  insurancePricesList: any[]|null = null;
  getSingleServiceInsurancePricesData(mixedID) {
    this.spinner.showSpinner('Loading...Please Wait');
    this.httpCall.get(`${environment.providerDomain}/BackEnd/getProviderTestInsuranceInfo/${mixedID}`).subscribe(res => {
      this.ipRes = true;
      this.spinner.stopSpinner();
      if (res['success']) {
        this.insurancePricesList = [ ...res['response']];
        this.filterColumns = res['response'];
        this._selectedColumns = res['response'].slice(0, 5);
        this.setGraphValues();
      } else {
        this.insurancePricesList = null;
      }
    }, (err) => {
      this.spinner.stopSpinner();
      this.snackbar.open(err.error['message'], 'Failed', {
        duration: 5000,
        panelClass: 'snackBar-failure'
      });
    });
  }

  async openInsurancePricesDialog(selectedItem?: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.disableClose = true;
    dialogConfig.minWidth = '30vw';
    dialogConfig.data = {
      proID: localStorage.getItem('proID'),
      selectedItem: selectedItem
    };
    const dialogRef = this.dialog.open(AddEditServiceInsurancePricesComponent, dialogConfig);
    dialogRef.beforeClosed().subscribe(data => {
      if (data) {
        if (data.success) {
          this.router.navigateByUrl(`shared/view-service-insurance-prices/${this.activatedRoute.snapshot.params.serviceID}/${data.response}`, {replaceUrl: true});
          // this.getSingleServiceInsurancePricesData(this.activatedRoute.snapshot.params.mixedID);
        }
      }
    });
  }

  showEditNote() {
    this.snackbar.open('You can update prices only from Charge Master insurance prices section', '', {
      duration: 5000,
      panelClass: 'snackBar-failure'
    });
  }

  chartOption: EChartOption;

  setGraphValues(){
    if(this.insurancePricesList){
      let sortedPrices = [...this._selectedColumns]

    sortedPrices.sort((a,b) => {
      if(!!sortedPrices[0].ip_price){
        return b.ip_price - a.ip_price
      }else{
        return b.op_price - a.op_price
      }
    })
    this.chartOption = {
      grid: { containLabel: true },
      legend: {},
      tooltip: {},
      dataset: {
        dimensions: ['carrier_name', 'ip_price', 'op_price'],
        source: sortedPrices
      },
      xAxis: {},
      yAxis: {
         type: 'category',
         axisLabel: {
          interval: 0,
          rotate: 0,
        },
        nameTextStyle: {
          fontSize: 6
        }
        },
      // Declare several bar series, each will be mapped
      // to a column of dataset.source by default.
      series: [
        { type: 'bar' ,
        itemStyle: {color: this.proThemes?.primary.bgColor ? this.proThemes?.primary.bgColor : '#20B04B'} ,
        label: {
          show: true,
          position: 'right',
          color: '#000000',
          formatter: function(c){
            if(c.value.ip_price==0){
              return 'N/A';
            }else{
              return `$${c.value.ip_price}`;
            }
          } }
        },
        { type: 'bar',
        itemStyle: {color: this.proThemes?.secondary.bgColor ? this.proThemes?.secondary.bgColor : '#FFB904'} ,
        label: {
          show: true,
          position: 'right',
          color: '#000000',
          formatter: function(c){
            if(c.value.op_price==0){
              return 'N/A';
            }else{
              return `$${c.value.op_price}`;
            }
          }}
        }
      ]
    };
    }
  }

  hexToRgbHead(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? `rgba(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}, 0.1)` : null;
  }
  hexToRgbBody(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? `rgba(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}, 0.05)` : null;
  }
}
